<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="projectStatusAddEditForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                formControlName="lableName"
                type="text"
                maxlength="50"
                class="input-custom-style"
                placeholder="Label"
              />
              <label>Label </label>
              <div *ngIf="submitted && projectStatusAddEditForm.controls['lableName'].errors">
                <div
                  *ngIf="projectStatusAddEditForm.controls['lableName'].errors?.['required']"
                  class="input-error"
                >
                  Label is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label
              *ngIf="projectStatusAddEditForm.get('organizationName')?.value"
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationlist"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearch"
              placeholder="All organization"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="organization.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                formControlName="position"
                type="number"
                maxlength="3"
                step="1"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                class="input-custom-style"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                placeholder="Position"
              />
              <label>Position</label>
              <div *ngIf="submitted && projectStatusAddEditForm.controls['position'].errors">
                <div
                  *ngIf="projectStatusAddEditForm.controls['position'].errors?.['required']"
                  class="input-error"
                >
                  Position is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row checkbox-text-margin">
        <div class="col-sm-6 d-flex">
          <div class="checkbox-text checkBoxAlienMent">
            <input
              type="checkbox"
              class="chkOverview"
              [(ngModel)]="activeCheckbox"
              formControlName="isPublic"
            />
            <span class="spaceText">Public</span>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
